import React from 'react'
import completedImg from "../../../../../../assets/images/photographerOnboarding/completed.svg"
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { openProjectModal } from '../../../../actions/landing_page_actions'

const CompletedFirstShootOfferComponent = (props) => {
  return (
    <div>
      <div className="content-wrapper">
        <div className="initial-info-container content-container">
          <div className="apply-for-discount-center-image-wrapper">
            <img src={completedImg} />
          </div>
          <h1 className="apply-for-discount-completed-title">
            You're all set!
          </h1>
          <div className="apply-for-discount-completed-description">
            Your discount code is on its way to your inbox. Ready to book your shoot?
          </div>
          <div className="lead-page-divider" />
          <div className="mar-bottom-30">
            <button 
              className="projectEditButton projectEditButtonBlue projectEditButtonLarger w-100" 
              onClick={() => props.openProjectModal()}>
              Schedule Shoot
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mdp = (dispatch) => ({
  openProjectModal: () => dispatch(openProjectModal())
})

export const CompletedFirstShootOffer = withRouter(connect(null, mdp)(CompletedFirstShootOfferComponent))